import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

export default function HeroSection({ stats }) {
  const navigate = useNavigate();
  return (
    <section className="relative bg-[#050505] text-white py-20 px-4 sm:px-6 lg:px-8 pt-32 overflow-hidden">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#00D26A]/10 blur-[120px] rounded-full"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#FFD700]/10 blur-[120px] rounded-full"></div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center space-y-8">
          <div
            className="inline-flex items-center gap-2 bg-[#00D26A]/20 border border-[#00D26A]/30 text-[#00D26A] px-4 py-2 rounded-full text-sm font-medium"
            data-testid="landing-validated-badge"
          >
            <Check className="w-4 h-4" />
            Validated with {stats?.validated_barcodes ?? 63} real-world barcodes
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tighter" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Find 2x More Profitable Items<br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#00D26A] to-[#FFD700]">From Your Phone</span>
          </h1>

          <p className="text-xl sm:text-2xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
            Join a community of flippers earning more together. One scan, all four buyers compared — no app-hopping.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/login')}
              className="bg-gradient-to-r from-[#00D26A] to-[#FFD700] text-black hover:opacity-90 font-bold px-8 py-4 rounded-full text-lg transition-all transform hover:translate-y-[-2px] shadow-[0_0_30px_rgba(0,210,106,0.3)]"
              data-testid="hero-start-scanning-btn"
            >
              🚀 Start Scanning Now
            </button>
            <a
              href="#waitlist"
              className="bg-transparent text-white border-2 border-[#FFD700] hover:bg-[#FFD700]/10 hover:border-[#FFD700] font-bold px-8 py-4 rounded-full text-lg transition-all shadow-lg"
            >
              Join Beta Waitlist - 3 Years Free (£540)
            </a>
          </div>

          <a
            href="#founding-100"
            className="inline-block text-sm text-[#FFD700] hover:text-[#00D26A] transition-colors underline decoration-dotted underline-offset-4"
            data-testid="hero-vip-link"
          >
            or skip the beta &mdash; join the Founding 100 (90% off for 3 years) →
          </a>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center text-sm text-zinc-300">
            <div className="flex items-center gap-2"><Check className="w-5 h-5 text-[#00D26A]" />2.23x multiplier on low-value items</div>
            <div className="flex items-center gap-2"><Check className="w-5 h-5 text-[#00D26A]" />Launching September 2026</div>
          </div>
        </div>
      </div>
    </section>
  );
}
